import React from 'react';

const IconWeixin = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="feather feather-weixin">
    <title>微信</title>
    <path d="M8.691 2.188C3.891 2.188 0 5.476 0 9.53c0 2.212 1.17 4.203 3.002 5.55a.59.59 0 0 1 .213.665l-.39 1.48c-.019.07-.048.141-.048.213 0 .163.13.295.29.295a.326.326 0 0 0 .167-.054l1.903-1.114a.864.864 0 0 1 .717-.098 10.16 10.16 0 0 0 2.837.403c.276 0 .543-.027.811-.05-.857-2.578.157-4.972 1.932-6.446 1.703-1.415 4.882-1.932 7.621-.55-.302-2.676-2.476-4.991-5.748-6.364a9.024 9.024 0 0 0-3.619-.272zM21.61 12.39c0-1.73-.97-3.27-2.406-4.33-1.416-1.043-3.301-1.043-4.717 0a5.063 5.063 0 0 0-1.605 2.061c-.297.731-.297 1.542 0 2.273.297.731.297 1.542 0 2.273a5.063 5.063 0 0 0 1.605 2.061c1.416 1.043 3.301 1.043 4.717 0 1.436-1.06 2.406-2.6 2.406-4.33z" />
  </svg>
);

export default IconWeixin;
